module.exports = function (obj, isEscape) {
  const Handlebars = require('handlebars/runtime');

  let result = '';
  const data = obj || {};
  if (isEscape === true) {
    result = JSON.stringify(data);
  } else {
    result = new Handlebars.SafeString(JSON.stringify(data));
  }
  return result;
};
